/**
 * Workaround for a Section Store app bug: the "Coupon code" block renders
 * inside a Shadow DOM web component (<section-store--coupon-block>), and the
 * app currently fails to inject the merchant's saved "Custom CSS" setting
 * into that shadow root's stylesheet. This script reads the already-saved
 * custom_css value straight out of the block's own data-settings attribute
 * (nothing new to configure) and appends it as a <style> tag inside the
 * shadow root, so the override actually takes effect.
 *
 * Safe to leave in place site-wide: it's a no-op on any page without a
 * <section-store--coupon-block> element, and it will stop overriding
 * anything correctly the moment Section Store fixes the underlying bug
 * (it just adds a style tag with no-op rules if custom_css is empty).
 */
(function () {
  var SELECTOR = 'section-store--coupon-block';
  var MAX_ATTEMPTS = 20; // ~6 seconds of polling at 300ms, to cover slow upgrades

  function tryInject(el) {
    var shadow = el.shadowRoot;
    if (!shadow) return false; // not upgraded yet, retry later

    var settingsRaw = el.getAttribute('data-settings');
    if (!settingsRaw) {
      el.setAttribute('data-custom-css-fixed', 'true');
      return true;
    }

    var settings;
    try {
      settings = JSON.parse(settingsRaw);
    } catch (e) {
      el.setAttribute('data-custom-css-fixed', 'true');
      return true;
    }

    el.setAttribute('data-custom-css-fixed', 'true');

    var customCss = settings && settings.custom_css;
    if (!customCss) return true;
    if (shadow.querySelector('style[data-custom-css-fix]')) return true;

    var styleEl = document.createElement('style');
    styleEl.setAttribute('data-custom-css-fix', '');
    styleEl.textContent = customCss;
    shadow.appendChild(styleEl);
    return true;
  }

  function processAll() {
    document
      .querySelectorAll(SELECTOR + ':not([data-custom-css-fixed="true"])')
      .forEach(tryInject);
  }

  var attempts = 0;
  var pollTimer = setInterval(function () {
    processAll();
    attempts++;
    if (attempts >= MAX_ATTEMPTS) clearInterval(pollTimer);
  }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  // Theme editor re-renders a section (e.g. merchant tweaks settings) -
  // give the fresh block another round of polling attempts.
  document.addEventListener('shopify:section:load', function () {
    attempts = 0;
    clearInterval(pollTimer);
    pollTimer = setInterval(function () {
      processAll();
      attempts++;
      if (attempts >= MAX_ATTEMPTS) clearInterval(pollTimer);
    }, 300);
  });

  // Catch blocks added to the DOM outside of a section:load event.
  var mo = new MutationObserver(function () {
    processAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
